import { render } from "./ActivityXComponents.vue?vue&type=template&id=5dd8f75c&scoped=true&ts=true"
import script from "./ActivityXComponents.vue?vue&type=script&lang=ts"
export * from "./ActivityXComponents.vue?vue&type=script&lang=ts"

import "./ActivityXComponents.vue?vue&type=style&index=0&id=5dd8f75c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd8f75c"]])

export default __exports__